<template>
  <div class="delivery">
    <img src="../../assets/delivery/1.png" alt="">
    <img src="../../assets/delivery/2.png" alt="">
    <img src="../../assets/delivery/3.png" alt="">
    <img src="../../assets/delivery/4.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'Delivery',
}
</script>

<style lang="scss" scoped>
.delivery{
  width: 100%;
  height: 100%;
  font-size: 0;
  img{
    width: 100%;
  }
}
</style>
